import { MAX_MENTIONS } from '../../../shared/mentions.js'
import { Icon } from '../icons/Icon.jsx'
import { SystemTile } from '../ui/SystemTile.jsx'
import styles from './Composer.module.css'

/**
 * The "Tag a system" popover opened by typing @. Pure view: state and keyboard
 * handling live in the composer, which bridges TipTap's suggestion plugin.
 */
export function MentionPicker({ items, highlighted, added, onPick, onHover, style, listId }) {
  return (
    <div className={styles.picker} style={style} role="dialog" aria-label="Tag a system">
      <div className={styles.pickerHead}>
        <span className="section-label">Tag a system</span>
        <span className={styles.pickerCount}>
          {added.length} of {MAX_MENTIONS} added
        </span>
      </div>
      {items.length === 0 ? (
        <p className={styles.pickerEmpty}>No system matches.</p>
      ) : (
        <ul aria-label="Systems" className={styles.pickerList} id={listId} role="listbox">
          {items.map((system, index) => {
            const isAdded = added.includes(system.slug)
            const noSkill = system.status === 'none'
            const full = !isAdded && added.length >= MAX_MENTIONS
            const disabled = noSkill || full
            const sub = noSkill
              ? 'No skill yet — add one in the library'
              : system.status === 'draft'
                ? `${system.categoryLabel} · draft skill`
                : `${system.categoryLabel} · skill v${system.published?.label ?? '—'}`
            return (
              <li key={system.slug}>
                <button
                  type="button"
                  role="option"
                  aria-selected={index === highlighted}
                  aria-pressed={isAdded}
                  disabled={disabled}
                  className={`${styles.pickerRow} ${index === highlighted && !disabled ? styles.pickerRowOn : ''} ${noSkill ? styles.pickerRowNoSkill : ''}`}
                  onMouseDown={(event) => event.preventDefault()}
                  onMouseEnter={() => onHover(index)}
                  onClick={() => onPick(system)}
                  title={full ? `Up to ${MAX_MENTIONS} systems per question` : undefined}
                >
                  <SystemTile system={system} size="picker" picker />
                  <span className={styles.pickerText}>
                    <span className={styles.pickerName}>{system.name}</span>
                    <span className={styles.pickerSub}>{sub}</span>
                  </span>
                  {isAdded ? (
                    <span className={styles.pickerAdded}>
                      <Icon name="check" size={14} strokeWidth={1.8} />
                      Added
                    </span>
                  ) : index === highlighted && !disabled ? (
                    <kbd className={styles.pickerEnter}>↵</kbd>
                  ) : null}
                </button>
              </li>
            )
          })}
        </ul>
      )}
      <div className={styles.pickerFoot}>
        <span>Tagged systems are answered from first</span>
        <span className={styles.pickerKeys}>
          <kbd>↑↓</kbd>
          <kbd>esc</kbd>
        </span>
      </div>
    </div>
  )
}
